export class Prompt {
    promptId: number = -1;
    categoryId: string = "";
    categoryName: string = "";
    isActive: boolean = false;
    name: string = "";
    text: string = "";
    createdAt: Date = new Date(1970, 1,1);
    updatedAt: Date = new Date(1970, 1,1);
}